interface PopupPosition {
  screenLeft: number;
  screenTop: number;
  innerWidth: number;
  innerHeight: number;
}

const popupPositionStorageKey = 'popupPosition';

class PopupManager {
  private popupPosition: PopupPosition | null = null;
  private popupWindowRef: Window | null = null;

  constructor() {
    const popupPositionString = localStorage.getItem(popupPositionStorageKey);
    if (popupPositionString != null) {
      this.popupPosition = JSON.parse(popupPositionString) as PopupPosition;
    }
  }

  public open(): void {
    if (this.popupWindowRef == null || this.popupWindowRef.closed) {
      const currentUrl = new URL(window.location.href);
      const popupWindow = window.open(
        `${currentUrl.toString()}popup`,
        '_blank',
        this.getPopupProperties(this.popupPosition)
      );

      this.popupWindowRef = popupWindow;
      window.onbeforeunload = () => {
        this.closePopup();
      };
      if (popupWindow != null) {
        popupWindow.onload = () => {
          popupWindow.onbeforeunload = () => {
            this.savePosition();
          };
        };
      }

      return;
    }
  }

  private savePosition(): void {
    if (this.popupWindowRef == null) {
      return;
    }
    this.popupPosition = {
      screenLeft: this.popupWindowRef.screenLeft,
      screenTop: this.popupWindowRef.screenTop,
      innerWidth: this.popupWindowRef.innerWidth,
      innerHeight: this.popupWindowRef.innerHeight,
    };
    localStorage.setItem(
      popupPositionStorageKey,
      JSON.stringify(this.popupPosition)
    );
  }

  public closePopup(): void {
    if (this.popupWindowRef == null) {
      return;
    }
    this.savePosition();
    this.popupWindowRef.close();
  }

  private getPopupProperties(position: PopupPosition | null): string {
    const defaultProps = 'toolbar=no,location=no,status=no,menubar=no';
    if (position == null) {
      return `width=1000,height=500,${defaultProps}`;
    }
    return `width=${position.innerWidth.toString()},height=${position.innerHeight.toString()},left=${position.screenLeft.toString()},top=${position.screenTop.toString()},${defaultProps}`;
  }
}

export default PopupManager;
